import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Reviews from './components/Reviews';
import WhyUs from './components/WhyUs';
import Order from './components/Order';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <div id="about">
        <About />
      </div>
      <div id="menu">
        <Menu />
      </div>
      <div id="reviews">
        <Reviews />
      </div>
      <WhyUs />
      <div id="contact">
        <Order />
      </div>
      <Footer />
    </div>
  );
}

export default App;
